import get from 'lodash-es/get'

import { getPropsFromNode, nodeIs, nodeListToArray, nodeMatches } from '../../utils'
import { ArticleFigure } from '../../../components/molecule/ArticleContent/entry'
import { extractAlignment, extractSide, FULL_WIDTH, getAlignmentProps, WIDE_WIDTH } from '../_utils'
import { h } from '../../parser/utils'

const LARGE_WIDTH_THRESHOLD = 200
const BACKGROUND_LOCATION_THRESHOLD = 2

export const NAME = 'block-image'

export const COMPONENTS = {
  ArticleFigure,
}

export function matches(node) {
  return nodeMatches(node, '.wp-block-image')
}

export async function transform (node, next, ctx) {
  const figure = nodeIs(node, 'figure') ? node : node.querySelector('figure')

  const nodes = nodeListToArray(figure.childNodes)

  const captionNode = figure.querySelector('figcaption')

  const [caption, children] = await Promise.all([
    parseCaption(
      captionNode,
      next,
      ctx,
    ),
    next(
      nodes.filter(node => node !== captionNode),
      ctx,
    ),
  ])

  const props = {
    ...getPropsFromNode(node, ['id', 'class', 'style']),
    ...(figure !== node ? getPropsFromNode(figure, ['id', 'class', 'style']) : {}),
    caption: caption.length ? caption : undefined,
  }

  const location = nodeListToArray(node.parentNode.childNodes).indexOf(node)

  return buildFigureComponent(
    {
      ...ctx,
      location,
    },
    figure,
    props,
    children,
  )
}

export function buildFigureComponent(ctx, node, props, children) {
  const alignment = extractAlignment(node)

  const nodeWidth = node.style.width && parseInt(node.style.width) || -1
  if (nodeWidth > 0) {
    props['style'] = [props['style'], `max-width: ${nodeWidth}px`].filter(item => !!item).join(';')
  }

  const hasWideAlignment = (alignment === FULL_WIDTH || alignment === WIDE_WIDTH)

  let figureProps = {
    ...props,
    ...getAlignmentProps(node),
    ...hasWideAlignment ? { boxed: { withBackground: true } } : {},
  }

  if (!hasWideAlignment && (ctx.level !== 1 || ctx.location > BACKGROUND_LOCATION_THRESHOLD)) {
    const side = extractSide(node)

    const width = nodeWidth > 0 ?
      nodeWidth :
      get(node.querySelector('img'), 'width', 0)

    const isLarge = width >= LARGE_WIDTH_THRESHOLD

    if (isLarge) {
      figureProps = {
        ...props,
        float: side,
        break: side,
        boxed: { withBackground: true },
      }
    }
  }

  return h(
    ArticleFigure,
    figureProps,
    ...children,
  )
}

export async function parseCaption(captionNode, next, ctx) {
  if (!captionNode) {
    return []
  }

  const captionNodes = nodeListToArray(captionNode.childNodes)

  const isAllText = !captionNodes.some(node => node.nodeType !== ctx.window.Node.TEXT_NODE)

  return isAllText ?
    captionNodes.map(node => h(
      'p',
      getPropsFromNode(captionNode),
      node.textContent?.replace(/^\s+/, ' ').replace(/\s+$/, ' ')
    )) :
    next(captionNodes, ctx)
}
